import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private langSubject = new BehaviorSubject<'en' | 'ar'>(
    (localStorage.getItem('lang') as 'en' | 'ar') || 'ar'
  );

  lang$ = this.langSubject.asObservable();

  constructor() {
    this.applyDir(this.langSubject.value);
  }

  get current(): 'en' | 'ar' {
    return this.langSubject.value;
  }

  setLang(lang: 'en' | 'ar'): void {
    localStorage.setItem('lang', lang);
    this.applyDir(lang);
    this.langSubject.next(lang);
  }

  toggle(): void {
    this.setLang(this.current === 'en' ? 'ar' : 'en');
  }

  private applyDir(lang: 'en' | 'ar'): void {
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }
}
